module.exports = __webpack_public_path__ + "static/media/newpost.8e4a11be.png";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/social/newpost.png
// module id = 689
// module chunks = 0